
import { defineComponent } from "vue";
import CobraSuccessView from "@/components/success/CobraSuccessView.vue";
import OpenSuccessView from "@/components/success/OpenSuccessView.vue";
import { mapGetters, mapMutations } from "vuex";
import helper from "@/utils/helper";
import routesPath from "@/config/routesPath";

export default defineComponent({
  components: { CobraSuccessView, OpenSuccessView },
  data() {
    return {
      enrollmentType: 0,
      totalEnrollments: 0,
    };
  },
  async created() {
    this.enrollmentType = this.getEnrollment.serviceType;
    this.totalEnrollments = this.getTotalEnrollments;
  },
  beforeRouteLeave(to, from, next) {
    helper.beforeRouterLeave(next);
  },
  computed: {
    ...mapGetters(["getEnrollment", "getTotalEnrollments"]),
  },
  methods: {
    async goToEnrollments() {
      this.$router.push({ name: routesPath.enrollments });
    },
  },
});
